import React from "react";

const CampusLife = () => {
  return (
    <div>
      <div className="py-[3px] px-1">
        <div className="rounded-t-[20px] w-full bg-rose-500 text-primary-content">
          <div className="card-body py-2 items-center text-center">
            <img className="w-[30px]" src="/culogo.png" alt="" />
            <h2 className="card-title text-white">Campus Life</h2>
          </div>
        </div>
      </div>
      {!navigator.onLine ? (
        <div className="text-center">
          <p>No internet. Please check your internet connection.</p>
        </div>
      ) : (
        ""
      )}

      <div>
        <div className="card-body py-1  items-center text-center text-black collapse collapse-arrow bg-indigo-50		">
          <input type="radio" name="my-accordion-2" />
          <div className="collapse-title text-xl font-medium">
            <h1>Overview</h1>
          </div>
          <div className="collapse-content">
            <p>
              The day begins with the chirping of birds, many of which are
              unique to this region. Exotic animals, such as Hilly ‘Maya’ deer,
              porcupine, squirrel, python, water monitor and different reptiles
              and snakes roam around the hilly jungle under broad daylight. When
              the darkness of night falls, wild foxes start howling, while
              nocturnal wild boars and pole-cats come out from their den to
              hunt. This is not a description of a safari park in Bangladesh.
              This is just a glance of the magnificent biodiversity that can be
              found in the University of Chittagong campus. The university has
              the second largest campus in the country, with over 1,700 acres of
              hilly and plain lands. The rows of trees alongside the hilly roads
              present a beautiful spectacle for the eyes, and the hilly streams
              soothe the tired visitors. There something for every everyone
              here, be it rows of hilly areas or the sunrise and sunset from the
              mountain peak. The ever-prevalent biodiversity and the scenic
              natural beauty attracts nature lovers and tourists seeking a taste
              of the remarkable campus tourism.
            </p>

            <img
              src="https://cu.ac.bd/assets/page/image/Page_1551931382_OSM43VTB45.png"
              alt=""
              sizes="200"
              srcset=""
            />
          </div>
        </div>

        <div className="card-body py-1 mt-1  items-center text-center text-black collapse collapse-arrow bg-indigo-50		">
          <input type="radio" name="my-accordion-2" />
          <div className="collapse-title text-xl font-medium">
            Residence Quarter
          </div>
          <div className="collapse-content">
            <p>Total Residential Capacity for Teachers : 103</p>
            <p>Total Residential Capacity for Officers : 45</p>
            <p>Total Residential Capacity for Staffs : 92</p>
            <p>Percentage of Residential Teachers : 8</p>
            <p>Percentage of Residential Officers : 11</p>
            <p>Percentage of Residential Staffs : 5</p>
          </div>
        </div>
        <div className="card-body py-1 mt-1  items-center text-center text-black collapse collapse-arrow bg-indigo-50		">
          <input type="radio" name="my-accordion-2" />
          <div className="collapse-title text-xl font-medium">
            Residence Halls
          </div>
          <div className="collapse-content grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 mx-2 pt-5">
            <div className="card w-full bg-base-100 shadow-xl">
              <figure className="px-10 pt-10">
                <img
                  src="https://cu.ac.bd/assets/image/sections/CWKCO8MI0K_alaolhall_resized.png"
                  alt="Alaol Hall"
                  className="rounded-xl"
                />
              </figure>
              <div className="card-body items-center text-center">
                <h2 className="card-title">Alaol Hall</h2>
              </div>
            </div>
            <div className="card w-full bg-base-100 shadow-xl">
              <figure className="px-10 pt-10">
                <img
                  src="https://cu.ac.bd/assets/image/sections/K3PPJX9GSQ_afrahmanhall_resized.png"
                  alt="A. F. Rahman Hall"
                  className="rounded-xl"
                />
              </figure>
              <div className="card-body items-center text-center">
                <h2 className="card-title">A. F. Rahman Hall</h2>
              </div>
            </div>

            <div className="card w-full bg-base-100 shadow-xl">
              <figure className="px-10 pt-10">
                <img
                  src="https://cu.ac.bd/assets/image/sections/TJXUX9QP9D_shahjalalhall_resized.png"
                  alt="Shahjalal Hall"
                  className="rounded-xl"
                />
              </figure>
              <div className="card-body items-center text-center">
                <h2 className="card-title">Shahjalal Hall</h2>
              </div>
            </div>
            <div className="card w-full bg-base-100 shadow-xl">
              <figure className="px-10 pt-10">
                <img
                  src="https://cu.ac.bd/assets/image/sections/NNNAI1ZK7J_suhrawardyhall_resized.png"
                  alt="Suhrawardy Hall"
                  className="rounded-xl"
                />
              </figure>
              <div className="card-body items-center text-center">
                <h2 className="card-title">Suhrawardy Hall</h2>
              </div>
            </div>

            <div className="card w-full bg-base-100 shadow-xl">
              <figure className="px-10 pt-10">
                <img
                  src="https://cu.ac.bd/assets/image/sections/BQK9RXN72N_amanathall_resized.png"
                  alt="Shah Amanat Hall"
                  className="rounded-xl"
                />
              </figure>
              <div className="card-body items-center text-center">
                <h2 className="card-title">Shah Amanat Hall</h2>
              </div>
            </div>
            <div className="card w-full bg-base-100 shadow-xl">
              <figure className="px-10 pt-10">
                <img
                  src="https://cu.ac.bd/assets/image/sections/G685T4JDJS_shamsunnaharhall_resized.png"
                  alt="Shamsun Nahar Hall"
                  className="rounded-xl"
                />
              </figure>
              <div className="card-body items-center text-center">
                <h2 className="card-title">Shamsun Nahar Hall</h2>
              </div>
            </div>
          </div>
        </div>

        <div className="card-body py-1 mt-1  items-center text-center text-black collapse collapse-arrow bg-indigo-50		">
          <input type="radio" name="my-accordion-2" />
          <div className="collapse-title text-xl font-medium">
            <h1>Health Center</h1>
          </div>
          <div className="collapse-content">
            <p>
              The Medical Center of the University of Chittagong, located near
              the Law Faculty Building, offers free medical service and free
              pathological examinations to students, teachers and staffs of the
              University and also family members of the teachers and staffs. The
              Center provides service round the clock, seven days a week, with
              doctors working in different shifts. The Center also has eleven
              doctors and four ambulances. The Center has in its premises a
              temporary arrangement for 6 bed accommodation.
            </p>
          </div>
        </div>

        <div className="card-body py-1 mt-1  items-center text-center text-black collapse collapse-arrow bg-indigo-50		">
          <input type="radio" name="my-accordion-2" />
          <div className="collapse-title text-xl font-medium">
            <h1>Transportation</h1>
          </div>
          <div className="collapse-content">
            <img
              src="https://cu.ac.bd/assets/page/image/Page_1551932982_BEHY8CSEML.png"
              alt=""
              sizes="200"
              srcset=""
            />

            <p className="py-2">
              University of Chittagong has transport services for students.
              Students can travel to the University Campus by Shuttle and DEMU
              Trains from the City. Besides, bus service is always available
              even on university holidays, to help those students who come to
              university for library or teacher's council.
            </p>
            <img
              src="https://i.ibb.co/GTwtxLk/cu-shuttle-train-schedule.png"
              alt=""
              sizes="200"
              srcset=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampusLife;
